import { __assign, __extends } from "tslib";
import LegendBase from '../base';
var DEFAULT_THEME = {
    layout: 'horizontal',
    titleDistance: 15,
    itemDistance: 5,
    itemMarginBottom: 8,
    wordSpacing: 8,
    backgroundPadding: 0,
    unSelectedColor: '#ccc',
    offsetX: 0,
    offsetY: 0,
};
var CategoryBase = /** @class */ (function (_super) {
    __extends(CategoryBase, _super);
    function CategoryBase(cfg) {
        return _super.call(this, __assign(__assign({ 
            /**
             * 鼠标 hover 到图例上的默认交互是否开启
             */
            hoverable: true, 
            /**
             * 图例是否允许点击交互
             */
            clickable: true, 
            /**
             * 图例项的选择模式，支持 'multiple'、'single'，默认 'multiple'
             */
            selectedMode: 'multiple', 
            /**
             * 是否允许全部取消，默认 false，即必须保留一个被选中
             */
            allowAllCanceled: false, 
            /**
             * 图例项的顺序是否要逆序，默认为 false
             */
            reversed: false, 
            /**
             * 是否自动换行，默认自动换行
             */
            autoWrap: true }, DEFAULT_THEME), cfg)) || this;
    }
    return CategoryBase;
}(LegendBase));
export default CategoryBase;
//# sourceMappingURL=base.js.map